// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkboxes_container__2XG4f","header":"Checkboxes_header__24FlD","back":"Checkboxes_back__3zgj0","backIcon":"Checkboxes_backIcon__e9FHa"};